<template>
    <div id="dashboard_page" class="page_body">
        <div class="page_heading">Dashboard</div>
        <SummaryOverview />
        <SummaryBoard v-on:toggle="updateForm"/>
        <SubmitForm v-if="submitFormVisibility"/>
        <UpdateForm
            v-if="updateFormVisibility"
            v-on:toggle="updateForm"
            v-on:formSubmitted="closeUpdateForm"
            v-bind:postData="post"
        />
    </div>
</template>

<script>
    import SummaryOverview from '../components/dashboard/SummaryOverview.vue';
    import SummaryBoard from '../components/dashboard/SummaryBoard.vue';
    import SubmitForm from '../components/dashboard/SubmitForm.vue';
    import UpdateForm from '../components/dashboard/UpdateForm.vue';

    export default {
        name: 'AppDashboard',
        data() {
            return {
                post: Object,
                updateFormVisibility: false,
                test: false
            }
        },
        mounted() {
            this.$store.dispatch('getAllBoardPostData');
            this.$store.dispatch('companyUsers');
        },
        components: {
            SummaryBoard,
            SummaryOverview,
            SubmitForm,
            UpdateForm,
        },
        computed: {
            submitFormVisibility() {
                return this.$store.state.Dashboard.submitFormVisibility;
            },
        },
        methods: {
            updateForm(postData) {
                this.post = postData;
                this.updateFormVisibility = !this.updateFormVisibility;
            },
            closeUpdateForm() {
                this.updateFormVisibility = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #dashboard_page{
        padding-top: 4rem;
        background-image: url('../assets/swirls.png');
        background-attachment: fixed;
        background-position: left center;
        background-size: 130%;
        background-repeat: no-repeat;

        .page_heading{
            font-size: 3rem;
            font-weight: 700;
            color: $primary-three;
            line-height: 1.3;
            margin-bottom: 4rem;
            margin-left: 5rem;
        }
    }
</style>